module.exports = __webpack_public_path__ + "static/img/female.a0992972.png";